import React, { useState, useEffect } from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";

import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";
import { Card } from "antd";

const SortableItem = ({ item }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
    width: 180,
  };

  return (
    <Card
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      cover={
        <img
          src={item.image}
          alt=""
          style={{ height: 120, objectFit: "cover" }}
        />
      }
    >
      <b>{item.title}</b>
      <br />
      {item.subtitle}
    </Card>
  );
};

const ImageGridSorter = ({ data, onChange }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (data && data.length) {
      setItems(data);
    }
  }, [data]);

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;

    if (active.id !== over.id) {
      const oldIndex = items.findIndex((i) => i.id === active.id);
      const newIndex = items.findIndex((i) => i.id === over.id);

      const newItems = arrayMove(items, oldIndex, newIndex);

      // UI update
      setItems(newItems);

      // Parent ko new order bhejo
      if (onChange) {
        onChange(newItems);
      }
    }
  };
  return (
    <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext
        items={items.map((i) => i.id)}
        strategy={rectSortingStrategy}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 16,
          }}
        >
          {items.map((item) => (
            <SortableItem key={item.id} item={item} />
          ))}
        </div>
      </SortableContext>
    </DndContext>
  );
};

export default ImageGridSorter;
